import fuzzysort from "fuzzysort";

const TITLE_TOKEN_MIN = 3;
const SIMILAR_LIMIT = 24;

function textValue(value) {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join(" ");
  }
  return value == null ? "" : String(value);
}

export function characterTags(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean);
  }
  if (typeof value === "string" && value.trim()) {
    return value
      .split(/[,\s]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  }
  return [];
}

function isSameArticle(source, item) {
  if (!item || item.id == null || !source) {
    return false;
  }
  if (item.id === source.id) {
    return true;
  }
  return item.vendor === source.vendor && item.slug === source.slug;
}

export default function FindSimilarFunction(
  id,
  terms,
  title,
  allMaterials,
  _orderBy,
  control,
) {
  const materials = Array.isArray(allMaterials) ? allMaterials : [];
  if (materials.length === 0) {
    return [];
  }

  const source = materials.find((item) => item.id === id) || null;
  const wantedTags = characterTags(terms);
  const subtype = String(control || source?.subtype || "")
    .trim()
    .toLowerCase();
  const queryTitle = String(title || source?.title || "").trim();

  const withoutSelf = (list) =>
    list.filter((item) => item && !isSameArticle(source, item) && item.id !== id);

  const sameSubtype = subtype
    ? materials.filter(
        (item) => String(item.subtype || "").trim().toLowerCase() === subtype,
      )
    : [];

  const withAllTags = wantedTags.length
    ? sameSubtype.filter((item) => {
        const tags = characterTags(item.character);
        return wantedTags.every((tag) => tags.includes(tag));
      })
    : sameSubtype;

  let typeMatches = withoutSelf(withAllTags);
  if (typeMatches.length === 0 && wantedTags.length > 1) {
    typeMatches = withoutSelf(
      sameSubtype.filter((item) => {
        const tags = characterTags(item.character);
        return wantedTags.some((tag) => tags.includes(tag));
      }),
    );
  }
  if (typeMatches.length === 0) {
    typeMatches = withoutSelf(sameSubtype);
  }

  const haystack = materials.map((item) => ({
    ...item,
    character: textValue(item.character),
    feature: textValue(item.feature),
  }));

  const fuzzyOptions = {
    limit: 20,
    allowTypo: true,
    threshold: -1000,
    keys: [
      "title",
      "description",
      "type",
      "subtype",
      "substrate",
      "search",
      "character",
      "feature",
    ],
  };

  const titleQueries = [queryTitle, ...queryTitle.split(/\s+/)]
    .map((token) => token.trim())
    .filter(
      (token, index, list) =>
        token.length >= TITLE_TOKEN_MIN && list.indexOf(token) === index,
    );

  const titleMatches = titleQueries.flatMap((query) =>
    fuzzysort.go(query, haystack, fuzzyOptions).map((result) => result.obj),
  );

  const seen = new Set();
  const merged = [];
  const accept = (item) => {
    if (!item || item.id == null || seen.has(item.id)) {
      return;
    }
    if (item.id === id || isSameArticle(source, item)) {
      return;
    }
    seen.add(item.id);
    merged.push(item);
  };

  titleMatches.forEach(accept);
  typeMatches.forEach(accept);

  return merged.slice(0, SIMILAR_LIMIT);
}
